// extracted by mini-css-extract-plugin
export default {"icon":"Typeahead_icon__VGd5A"};